import React from 'react';
import { Col, Container, Row, Button } from 'react-bootstrap';
import mahedi from './../../img/mahedi.png'
import { FaLinkedin, FaGithub } from "react-icons/fa";
import './Header.css'

const Header = () => {
    return (
        <>
            <Container className="my-5">
                <Row className="d-flex align-items-center justify-content-center">
                    <Col md={6}>
                        <h1>Md <span className="text-primary">Mahedi</span> Hassan</h1>
                        <h3 className="fw-bold">Web Developer</h3>
                        <p> I am skilled in JavaScript, ES6, React, React-Bootstrap, React Router, Firebase. I have also known Node.js, Express, MongoDB. I complete some projects with React, Node.js, Express, MongoDB, Firebase.</p>
                        <Button variant="outline-info"> <a style={{ textDecoration: "none", fontWeight: "700", color: "black" }} href="https://drive.google.com/file/d/10byv4u-59brdMudrKYczEPvJXaaKn49U/view" target="blank">RESUME</a> </Button>
                        <a href="https://www.linkedin.com/in/md-mh/" target="blank"><FaLinkedin /></a>
                        <a href="https://github.com/md-mh" target="blank"><FaGithub /></a>
                    </Col>
                    <Col md={6} style={{ textAlign: "center" }}>
                        <img className="avater" src={mahedi} alt="" />
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Header;